<template>
  <div class="warp">
    <div class="warp1">
      <div class="top">
        <div class="top_cent">
         <div class="top_p">
            <div class="top_cent_p">
              <i class="el-icon-location"></i>
              <el-dropdown trigger="click" class="koaa">
                <!-- <span class="el-dropdown-link" v-if="namee == ''">
              天津市
              <i class="el-icon-arrow-down el-icon--right"></i>
                </span>-->
                <span class="el-dropdown-link" v-if="getCitys[citr].city_name">
                  {{getCitys[citr].city_name}}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown" class="koa">
                  <el-dropdown-item
                    v-for="(item,index) in getCitys"
                    :key="index"
                    @click.native="dropdown(item.id,index)"
                  >{{item.city_name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <i class="el-icon-arrow-down icon"></i> -->
            </div>
            <p>|</p>
            <p style="margin-top:2px;">
              <img src="../../assets/img/top_btn_home.png" alt />
            </p>
            <router-link :to="{name:'login'}" tag="p" style="padding:0;">
              <a href="#" class="aa">商企服首页</a>
            </router-link>
          </div>
          <ul class="top_ul">
            <li @click="dialogVisible = true">
              <a href="#">登录</a>
            </li>
            <li>|</li>
            <li @click="dialogVisible1 = true">
              <a href="#">注册</a>
            </li>
            <li>
              <a href="https://coc.sqifu.com" target="_blank">商会后台</a>
            </li>
            <router-link :to="{path:'/fuwushang'}" tag="li">
              <a href="#">卖家中心</a>
            </router-link>
            <li>
              <a href="http://zf.sqifu.com">政府机构</a>
            </li>
            <li>
              <i class="el-icon-phone"></i>022-8821-9596
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!--面包屑 -->
    <div class="mianbo">
      <div class="mianbo_1">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="mianbo_2">
          <el-breadcrumb-item :to="{ path: '/guanyu' }">关于商企服</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path:'/guanyu'}">商企资讯</el-breadcrumb-item>
          <el-breadcrumb-item>商企资讯</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <div class="content_1">
        <div class="content_left">
          <p class="content_left_p">{{lists.article_name}}</p>
          <p class="content_left_p_2">发布时间：{{lists.update_time}}</p>
          <ul class="content_left_ul">
            <li style="text-indent:18px;letter-spacing:2px;," v-html="lists.text">{{lists.text}}</li>
            <!-- <li
              style="text-indent:20px;letter-spacing:2px;,"
            >“要牢记空谈误国、实干兴邦的道理，坚持知行合一、真抓实干，做实干家”。在中央党校（国家行政学院）中青年干部培训班开班式上，习近平总书记突出强调了在摸爬滚打中增长才干、在层层历练中积累经验对于干部成长的重要性，勉励广大干部特别是年轻干部要在知行合一中主动担当作为，做起而行之的行动者、不做坐而论道的清谈客，当攻坚克难的奋斗者、不当怕见风雨的泥菩萨。习近平总书记的一席话，为干部正心修身树立了重要准则，为干事创业指明了行动方向。</li>
            <li
              style="text-indent:20px;letter-spacing:2px;,"
            >知者行之始，行者知之成。面对十分复杂的国内外环境，肩负繁重的执政使命，我们要加强理论学习，紧密结合新时代新实践，紧密结合思想和工作实际，多思多想、学深悟透，真正弄清楚创新理论的源泉是什么、实践基础是什么、战略考量是什么。我们强调武装头脑、指导实践、推动工作，落脚点应该在指导实践、推动工作；学懂弄通做实，落脚点在做实。创新理论学习得怎么样，掌握得如何，要在实践中接受检验，在担当作为中得到体现。</li>
          </ul>
          <div class="img1">
            <img :src="lists.img" alt />
          </div>
          <ul class="content_left_ul1">
            <li
              style="text-indent:30px;letter-spacing:1px;,"
            >在知行合一中主动担当作为，就要真抓实干、做实干家。广大干部要面对大是大非敢于亮剑，面对矛盾敢于迎难而上，面对危机敢于挺身而出，面对失误敢于承担责任，面对歪风邪气敢于坚决斗争，做疾风劲草、当烈火真金。人须在事上磨，方立得住。习近平总书记曾多次举战国赵括纸上谈兵、两晋学士虚谈废务的例子，就是警示领导干部要加强实践锻炼、真刀真枪打拼。干部成长无捷径可走，经风雨、见世面才能壮筋骨、长才干。在一个岗位工作，千万不能心浮气躁，要稳得住、沉得下，学真本领，练真功夫，把火热的实践作为最好的课堂，当几回“热锅上的蚂蚁”，在难事急事的经历中经受摔打。</li>
            <li
              style="text-indent:30px;letter-spacing:1px;,"
            >在知行合一中主动担当作为，就要敢于负责、勇于担当。能否敢于负责、勇于担当，最能看出一个干部的党性和作风。统筹推进“五位一体”总体布局、协调推进“四个全面”战略布局，贯彻落实新发展理念，打好三大攻坚战，做好稳增长、促改革、调结构、惠民生、防风险、保稳定工作，等等，都需要担当，都需要发扬斗争精神、提高斗争本领。实践告诉我们，有多大担当才能干多大事业，尽多大责任才会有多大成就。为官避事平生耻，越是艰险越向前，要用知重负重、攻坚克难的实际行动，诠释对党的忠诚、对人民的赤诚。</li>
            <li
              style="text-indent:30px;letter-spacing:1px;,"
            >中华民族伟大复兴，绝不是轻轻松松、敲锣打鼓就能实现的。新时代需要干部奋斗，需要干部主动担当作为。加强政治训练、党性锻炼，加强马克思主义理论武装，做到既有宽肩膀，又有铁肩膀，既政治过硬，又本领高强，广大干部就一定能不辱使命、不负重托，我们就一定能建设一支忠实贯彻习近平新时代中国特色社会主义思想、全心全意为人民服务，适应新使命新任务新要求、经得起风浪考验，数量充足、充满活力的高素质专业化年轻干部队伍。3月3日下午，区政务服务办召开了青年干部座谈会。全办46名青年干部参加了会议。全办46名青年干部结合自身工作实际，立足岗位讲述工作心得，畅谈青春梦想，同时也总结了自己在工作中的不足之处。在交流发言过程中互相学习经验，提高思想认识，并就如何进一步推动“一制三化”改革提出了各自的建议和想法。最后，会议对青年干部提出要求和希望，鼓励青年干部要增强自信、勤学善思，要不断增强自身的使命感和责任感，充分发挥自身的价值。要时刻保持清晰的头脑，用时间锤炼磨砺自己，高标准、严要求，激发自己的潜力，发挥工匠精神，在改革道路上继续前行，贡献力量。</li> -->
          </ul>
        </div>
        <!-- <div class="content_right">
          <div class="content_right_1">
            <div class="content_right_2">
              <img src="../../assets/img/guanyu/news_sign.png" alt />
              <p>新闻资讯</p>
            </div>
            <div class="content_right_bot">
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">坚持知行合一 主动担当作为主动担当作为主动担当作为主动担当作为主动担当作为</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">河西区政务服务办组织召开青...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">河西区政务服务办组织召开青...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">河西区政务服务办组织召开青...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
            </div>
          </div>
          <div class="content_right_1">
            <div class="content_right_2">
              <img src="../../assets/img/guanyu/news_sign.png" alt />
              <p>行业动态</p>
            </div>
            <div class="content_right_bot">
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">坚持知行合一 主动担当作为主动担当作为主动担当作为主动担当作为主动担当作为</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">河西区政务服务办组织召开青...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">河西区政务服务办组织召开青...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">河西区政务服务办组织召开青...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
              <p>
                <img src="../../assets/img/guanyu/news_sign_nor.png" class="img_hover" alt />
                <img src="../../assets/img/guanyu/news_sign_pre.png" class="img_hover1" />
                <a href="#">天津市进一步推进供给侧结构...</a>
              </p>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- di'bu -->
    <div class="floor">
      <div class="floor_1">
        <img src="../../assets/img/bottom_logo_white.png" alt class="img" />
        <ul>
          <li @click="floor()">
            <a href="#">关于商企服</a>
          </li>
          <li @click="leimu()">
            <a href="#">商企服服务平台</a>
          </li>
          <li>
            <a href="#">|</a>
          </li>
          <li>
            <a href="#">联系电话：022-8821-9596</a>
          </li>
          <p>Copyright © 1998 - 2019 newcoc. All Rights Reserved.</p>
        </ul>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">登录</a>
        </div>
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==0">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div> -->
        </div>
      </div>
      <div class="login2_1" v-show="num==1">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible1" width="760px" height="473px">
      <div class="login1">
        <div :class="{active:1==num}" @click="num=1">
          <a href="#">登录</a>
        </div>
        <div :class="{active:0==num}" @click="num=0">
          <a href="#">注册</a>
        </div>
      </div>
      <div class="login1_1" v-show="num==1">
        <img src="../../assets/img/pop_bg_login.png" alt class="login1_img" />
        <div class="login1_2">
          <div class="login1_2_left">
            <div class="login1_2_erro1">
              <div class="login1_2_erro" v-show="cang">
                <img src="../../assets/img/pop_icon_error.png" alt />
                <p>手机号格式错误！</p>
              </div>
            </div>
            <div class="login1_2_login">
              <div class="login1_2_tel">
                <el-form>
                  <el-form-item prop="phone" class="pr">
                    <el-input placeholder="请输入手机号" class="input1" v-model="form.phone"></el-input>
                    <button @click="getCode(form)" class="code-btn" :disabled="!show">
                      <span v-show="show">获取验证码</span>
                      <span v-show="!show" class="count">重新发送({{count}})</span>
                    </button>
                  </el-form-item>
                  <el-form-item class="pr" prop="ecord">
                    <el-input placeholder="请输入验证码" class="input1" v-model="form.ecord"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="login1_2_denglu" @click="login()">
                <p>
                  <a href="#">登录</a>
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="login1_2_right">
            <img src alt />
          </div> -->
        </div>
      </div>
      <div class="login2_1" v-show="num==0">
        <div class="login2_1_one">
          <div class="login1_2_erro1">
            <div class="login1_2_erro" v-show="cang">
              <img src="../../assets/img/pop_icon_error.png" alt />
              <p>手机号格式错误！</p>
            </div>
          </div>
          <div class="login2_1_two">
            <el-form>
              <el-form-item class="pr" prop="name">
                <el-input placeholder="请输入姓名" class="input1" v-model="formLogon.name"></el-input>
              </el-form-item>
              <el-form-item prop="phone" class="pr">
                <el-input placeholder="请输入手机号" class="input1" v-model="formLogon.phone"></el-input>
                <button @click="getCode1(formLogon)" class="code-btn" :disabled="!show">
                  <span v-show="show">获取验证码</span>
                  <span v-show="!show" class="count">重新发送({{count}})</span>
                </button>
              </el-form-item>
              <el-form-item class="pr" prop="ecord">
                <el-input placeholder="请输入验证码" class="input1" v-model="formLogon.ecord"></el-input>
              </el-form-item>
              <el-form-item class="pr" prop="enterprise_name">
                <el-input placeholder="请输入公司名称" class="input1" v-model="formLogon.enterprise_name"></el-input>
              </el-form-item>
              <el-form-item class="pr">
                <el-cascader
                  :options="options"
                  :props="defaultParams"
                  :change-on-select="true"
                  :clearable="true"
                  v-model="formLogon.office_address_province_id"
                  @change="handleChange"
                  ref="cascaderAddr"
                  style="width:322px"
                ></el-cascader>
              </el-form-item>
              <el-form-item class="pr" prop="detailed_address">
                <el-input
                  placeholder="请输入公司详细地址"
                  class="input1"
                  v-model="formLogon.detailed_address"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="login_three">
              <img src="../../assets/img/pop_btn_xy_nor.png" @click="munn()" v-show="num1==2" />
              <img src="../../assets/img/pop_btn_xy_sel.png" @click="munn1()" v-show="num1==1" />
              <p>
                我已阅读并同意
                <a href="#" style="color:#007BFF">《商企服平台用户服务协议》</a>
              </p>
            </div>
            <div class="login1_2_denglu" @click="getlogon">
              <p>
                <a href="#">注册</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getArticleById } from "@/http/api";
import { getLoginphone, getLogin, getRegionList, getLogon } from "@/http/api";
export default {
  data() {
    return {
      value1: "",
      lists: [],
      //登录
      dialogVisible: false,
      dialogVisible1: false,
      num: 0,
      TIME_COUNT: 60, //验证码倒计时60s
      form: {
        phone: "",
        ecord: ""
      },
      formLogon: {
        phone: "",
        ecord: "",
        name: "",
        enterprise_name: "",
        office_address_province_id: "",
        detailed_address: ""
      },
      count: "",
      show: true,
      cang: false,
      num1: 2,
      options: [],
      defaultParams: {
        label: "name",
        value: "id",
        children: "children"
      },
      //划过
      munn() {
        this.num1 = 1;
      },
      munn1() {
        this.num1 = 2;
      },
      getCitys:[]
    };
  },
  methods: {
    // 跳转
    floor(){
      this.$router.push({ name: "guanyu" });
    },
    leimu() {
      this.$router.push({ name: "home" });
    },
    getArticleByid(id) {
      getArticleById({ article_id: id }).then(res => {
        this.lists = res.data.data;
      });
    },
     //登录
    getCode(form) {
      if (!/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.form.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.form.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    login() {
      if (this.form.ecord == "") {
        this.$message({
          message: "请输入验证码"
        });
      } else {
        getLogin({
          phone: this.form.phone,
          ecord: this.form.ecord
        }).then(res => {
          console.log(res);
          this.login_login = res.data;
          console.log(this.login_login);
          if (res.data.errcode === 200) {
            this.dialogVisible = false;
            this.$message({
              message: "登录成功",
              type: "success"
            });
            this.$router.push({
              name: "home",
              query: {
                id: res.data.data.name,
                idimg: res.data.data.photo,
                token: res.data.data.token
              }
            });
            localStorage.setItem("name", res.data.data.name);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("phone", res.data.data.phone);
            localStorage.setItem("photo", res.data.data.photo);
            localStorage.setItem("member_id", res.data.data.member_id);
            localStorage.setItem("is_service", res.data.data.is_service);
          } else if (res.data.errcode == 406) {
            this.$message({
              message: "账号信息不存在，请先注册"
            });
          }
        });
      }
    },
    //注册并登录
    getCode1(formLogon) {
      if (!/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = !this.cang;
      } else if (/^1[34578]\d{9}$/.test(this.formLogon.phone)) {
        this.cang = false;
        getLoginphone({ phone: this.formLogon.phone }).then(res => {
          console.log(res);
        });
        if (!this.timer) {
          this.count = this.TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= this.TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      }
    },
    getlogon() {
      getLogon({
        name: this.formLogon.name,
        phone: this.formLogon.phone,
        ecord: this.formLogon.ecord,
        enterprise_name: this.formLogon.enterprise_name,
        office_address_province_id: this.formLogon.office_address_province_id,
        detailed_address: this.formLogon.detailed_address
      }).then(res => {
        this.logon_logon = res.data.errcode;
        if (res.data.errcode == 200) {
          this.$router.push({
            name: "home",
            query: {
              id: this.formLogon.name
            }
          });
          localStorage.setItem("name", this.formLogon.name);
            localStorage.setItem("is_service", res.data.data.is_service);
        }
        if (res.data.errcode === 20001) {
          this.$message({
            message: "该手机号已经是会员",
            type: "success"
          });
        }
      });
    },
    handleChange(value) {
      console.log(value);
      let labels = this.$refs["cascaderAddr"].currentLables;
      console.log(this.$refs["cascaderAddr"]);
    },
    getRegion() {
      getRegionList({}).then(res => {
        console.log(res);
        this.options = res.data.data;
      });
    },
    checlogin() {
      this.token = localStorage.getItem("token");
      this.$http(
        "https://coc.sqifu.com/WebProgram/Base/checklogin",
        {
          token: this.token
        },
        "post"
      ).then(res => {
        if (res.data.errcode === 20001) {
          this.$emit("header", false); //是否显示头部
        } else {
          this.$emit("header", true); //是否显示头部
        }
      });
    },
    getCity() {
      this.$http("https://ctapi.sqifu.com/api/v1/getCityList", {}, "post").then(
        res => {
          this.getCitys = res.data.data;
        }
      );
    },
    dropdown(id, index) {
      this.citr = index;
      localStorage.setItem("city_id", id);
      localStorage.setItem("citr", this.citr);
      this.$router.go(0);
    }
  },
  created() {
    var id = this.$route.query.id;
    this.getArticleByid(id);
    this.getRegion(); //城市
    this.checlogin();
    this.citr = localStorage.getItem("citr");
    this.getCity();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.img1 img {
  width: 656px;
  height: 505px;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #f5f6fa;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.aa {
  color: #222222;
}

.top_p {
  font-size: 14px;
  color: #222222ff;
  line-height: 40px;
  float: left;
}

.top_p p {
  float: left;
  padding: 0 12px;
}

.top_cent_p {
  color: #007bffff;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: auto;
  height: auto;
  display: flex;
  float: right;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
}

.top_ul li a {
  color: #666666;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
}

.floor {
  width: 100%;
  height: 139px;
  background: #2d3236;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.img {
  padding: 54px 0;
  float: left;
}

.floor_1 ul {
  width: 480px;
  height: 96px;
  float: right;
  padding: 44px 0;
}

.floor_1 ul li a {
  float: left;
  padding: 0 0 0 33px;
  color: #ffffff;
  font-size: 14px;
}
.floor_1 ul p {
  font-size: 14px;
  font-weight: 400;
  float: right;
  color: #85919aff;
  padding: 20px 0;
}

.mianbo {
  width: 100%;
  height: 48px;
  margin-bottom: 38px;
}

.mianbo_1 {
  width: 1200px;
  margin: 0 auto;
}

.mianbo_2 {
  line-height: 48px;
  margin-left: 15px;
}

.content {
  width: 100%;
}

.content_1 {
  width: 1000px;
  height: auto;
  margin: 0 auto;
}

.content_left {
  width: 657px;
  height: auto;
  float: left;
  margin-bottom: 50px;
}

.content_right {
  width: 264px;
  height: auto;
  float: right;
}

.content_right_1 {
  width: 100%;
  height: 478px;
  background: #f4f5f9;
  margin-bottom: 28px;
}

.content_right_2 {
  width: 100%;
  height: 44px;
  margin-bottom: 15px;
}

.content_right_2 img {
  float: left;
  margin-right: 15px;
}

.content_right_2 p {
  float: left;
  font-size: 20px;
  font-weight: 600;
  line-height: 44px;
}

.content_right_bot {
  width: 244px;
  height: auto;
  float: right;
}

.content_right_bot p {
  width: 244px;
  height: 50px;
  border-bottom: 1px solid #e4e4e4;
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.content_right_bot p a {
  font-size: 14px;
  color: #666666;
  line-height: 50px;
  padding: 0 20px;
}

.content_left_p {
  width: 100%;
  height: 60px;
  border-bottom: 2px solid #067eff;
  font-size: 34px;
  margin-bottom: 10px;
}

.content_left_p_2 {
  float: right;
  font-size: 14px;
  margin-bottom: 30px;
}

.content_left_ul {
  width: 100%;
  height: 326px;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_left_ul li {
  font-size: 14px;
  line-height: 25px;
  color: #222222;
  font-family: Microsoft YaHei;
  margin-bottom: 15px;
}

.img1 {
  width: 100%;
  height: 505px;
  margin-bottom: 30px;
}

.content_left_ul1 {
  width: 100%;
  height: 664px;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_left_ul1 li {
  font-size: 14px;
  line-height: 25px;
  color: #222222;
  font-family: Microsoft YaHei;
  margin-bottom: 15px;
}

.img_hover {
  /* display: none; */
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: -32px;
  overflow: hidden;
}

.img_hover1 {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: -32px;
  overflow: hidden;
}

.content_right_bot p:hover a {
  color: #007bff;
}

.content_right_bot p:hover .img_hover {
  display: none;
}

.content_right_bot p:hover .img_hover1 {
  display: block;
}

/* denglu */
.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  margin: 0 auto;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro1 {
  width: 322px;
  height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
  position: relative;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}
.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  margin-bottom: 20px;
}

.login2_1_one {
  width: 322px;
  height: 550px;
  margin: 20px auto;
}

.login_three {
  width: 100%;
  height: 20px;
  margin-bottom: 20px;
}

.login_three img {
  float: left;
  padding: 0 5px 0 0;
}

.login_three p {
  float: left;
  line-height: 15px;
}

.top_ul li a {
  color: #666666;
}

.koa {
  width: auto;
  text-align: center;
  margin-top: -5px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/Guanyu/Zixun.vue